// Generated by `npm run monkseal` (scripts/monkseal.ts), from no archive: Maui Nui's Hawaiian monk
// seals on the last day of 2024, Maui Nui's share of NOAA's count of the main islands (PIFSC 2025)
// in the ages the seals' rates settle into, and the factor those rates grow them by a year; the adult
// females' pups the one number fitted, to NOAA's life table's 1.050 a year (PIFSC 2025, Table 4);
// every other figure a report's (src/sim/seals.ts). Do not edit by hand.
// tests/monkseal.test.ts holds it to a year's step.
import type { SealState } from '../../types';

/** The adult females' pups a year, fitted so the seals grow as NOAA's life table for the main islands does. */
export const MONK_SEAL_ADULT_PUPS = 0.6906162;

/** The factor the seals grow by a year at their rates, their ages settled. */
export const MONK_SEAL_GROWTH = 1.0500000;

/** The year whose first of January the table opens. */
export const MONK_SEAL_TABLE_YEAR = 2025;

/** The seals on the census year's last day (expected values; a world opening rounds them): weaned by year class since birth, nursing by days since birth. */
export const MONK_SEAL_TABLE: SealState = {
  counts: [15.5365, 12.4969, 10.3167, 8.82617, 7.66524, 6.74541, 5.93596, 5.22364, 4.59681, 4.04519, 3.55977, 3.13259, 2.75668, 2.42588, 2.13478, 1.8786, 1.65317, 1.45479, 1.28751, 1.14405, 1.01657, 0.903292, 0.802639, 0.713202, 0.633731, 0.563115, 0.500368, 0.444613, 0.39507, 0.351048, 0.311931, 0.277173, 0.246288],
  nursing: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
};
